import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const cache = {};

// Home « À propos » + FAQ texts, editable in Admin › Paramètres (falls back to locale strings while loading / on error)
export const useHomeContent = (lang) => {
  const [data, setData] = useState(cache[lang] || null);
  useEffect(() => {
    if (cache[lang]) { setData(cache[lang]); return; }
    let on = true;
    axios.get(`${API}/api/home-content`, { params: { lang } })
      .then((r) => { cache[lang] = r.data; if (on) setData(r.data); })
      .catch(() => { if (on) setData(null); });
    return () => { on = false; };
  }, [lang]);
  return data;
};

export const invalidateHomeContent = () => { Object.keys(cache).forEach((k) => delete cache[k]); };
